import React from 'react';
import styles from './Home.module.css';

const Home = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.h1}>Bem-Vindo</h1>
    </div>
  );
};

export default Home;
